const theme = {
  regularTextColor: "#292a32",
  grayTextColor: "#555765",
  accentColor: "rgb(255, 47, 110)",
};

export default theme;
